import React from 'react';
import '@/App.css';
import { LanguageProvider } from './context/LanguageContext';
import { Navigation } from './components/Navigation';
import { HeroSection } from './components/HeroSection';
import { StorySection } from './components/StorySection';
import { BenefitsSection } from './components/BenefitsSection';
import { ProductSection } from './components/ProductSection';
import { WhySection } from './components/WhySection';
import { PurchaseSection } from './components/PurchaseSection';
import { Footer } from './components/Footer';

function App() {
  return (
    <LanguageProvider>
      <div className="App bg-[#FDFBF7]" data-testid="app-container">
        <Navigation />
        <main>
          <HeroSection />
          <StorySection />
          <BenefitsSection />
          <ProductSection />
          <WhySection />
          <PurchaseSection />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
